<template>
  <span class="co-badge-required co-display-14 badge rounded border-0 bg-co-warning-500 p-2 text-co-gray-50">
    <slot>必須</slot>
  </span>
</template>
